//----- AUTOGENERATED (changes will be overwritten) -------
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dResult from "../Data.Result/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment from "../Restaumatic.Geocoding.Types.StreetAddressWithApartment/index.js";
import * as Restaumatic$dValidation$dTypes from "../Restaumatic.Validation.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq = /* #__PURE__ */ (() => {
  const $0 = Data$dEq.eqArrayImpl(Restaumatic$dValidation$dTypes.eqError.eq);
  return x => y => {
    if (x.tag === "Left") {
      if (y.tag === "Left") { return $0(x._1)(y._1); }
      return false;
    }
    if (x.tag === "Right") {
      if (y.tag === "Right") { return x._1 === y._1; }
      return false;
    }
    return false;
  };
})();
const resultIsSymbol = {reflectSymbol: () => "result"};
const ClaimFODResponseIsSymbol = {reflectSymbol: () => "ClaimFODResponse"};
const emailIsSymbol = {reflectSymbol: () => "email"};
const phoneIsSymbol = {reflectSymbol: () => "phone"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const streetAddressIsSymbol = {reflectSymbol: () => "streetAddress"};
const ClaimFODRequestIsSymbol = {reflectSymbol: () => "ClaimFODRequest"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const ClaimFODResponse = x => x;
const ClaimFODRequest = x => x;
const eqClaimFODResponse = {eq: x => y => eq(x.result)(y.result)};
const eqClaimFODRequest = {
  eq: x => y => x.email === y.email && x.phone === y.phone && x.restaurantId === y.restaurantId && (() => {
    if (x.streetAddress.tag === "Nothing") { return y.streetAddress.tag === "Nothing"; }
    if (x.streetAddress.tag === "Just") {
      if (y.streetAddress.tag === "Just") {
        return (() => {
          if (x.streetAddress._1.apartmentNumber.tag === "Nothing") { return y.streetAddress._1.apartmentNumber.tag === "Nothing"; }
          if (x.streetAddress._1.apartmentNumber.tag === "Just") {
            if (y.streetAddress._1.apartmentNumber.tag === "Just") { return x.streetAddress._1.apartmentNumber._1 === y.streetAddress._1.apartmentNumber._1; }
            return false;
          }
          return false;
        })() && x.streetAddress._1.city === y.streetAddress._1.city && x.streetAddress._1.street === y.streetAddress._1.street && x.streetAddress._1.streetNumber === y.streetAddress._1.streetNumber;
      }
      return false;
    }
    return false;
  })()
};
const rpcMethodNameClaimFODRequest = {rpcMethodName: v => "ClaimFODRequest"};
const newtypeClaimFODResponse = {Coercible0: () => {}};
const newtypeClaimFODRequest = {Coercible0: () => {}};
const hasFieldClaimFODResponse = dictHasField => dictHasField;
const hasFieldClaimFODRequest = dictHasField => dictHasField;
const genericClaimFODResponse = {to: x => x, from: x => x};
const showClaimFODResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dValidation$dTypes.showError.show);
      return {
        genericShowArgs: v => [
          (() => {
            if (v.result.tag === "Left") { return "{ result: (Left " + $0(v.result._1) + ") }"; }
            if (v.result.tag === "Right") {
              if (v.result._1) { return "{ result: (Right true) }"; }
              return "{ result: (Right false) }";
            }
            $runtime.fail();
          })()
        ]
      };
    })())(ClaimFODResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeClaimFODResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(resultIsSymbol)(Data$dResult.udecodeResult({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dValidation$dTypes.udecode.unsafeDecode)
    })(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericClaimFODRequest = {to: x => x, from: x => x};
const showClaimFODRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ email: " + Data$dShow.showStringImpl(v.email) + ", phone: " + Data$dShow.showStringImpl(v.phone) + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + (() => {
          if (v.streetAddress.tag === "Just") {
            return ", streetAddress: (Just " + Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.showStreetAddressWithApartment.show(v.streetAddress._1) + ") ";
          }
          if (v.streetAddress.tag === "Nothing") { return ", streetAddress: Nothing "; }
          $runtime.fail();
        })() + "}"
      ]
    })(ClaimFODRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeClaimFODRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(emailIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(phoneIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(streetAddressIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.unscrambleDecodeStreetAddressWithApartment))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodingOpts = {...Foreign$dGeneric$dClass.defaultOptions, unwrapSingleConstructors: true, unwrapSingleRecordArguments: true};
const encodeClaimFODResponse = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor(ClaimFODResponseIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(resultIsSymbol)((() => {
        const $0 = Data$dFunctor.arrayMap(Restaumatic$dValidation$dTypes.encodeError.encode);
        return {
          encodeWithOptions: v => v$1 => {
            if (v$1.tag === "Left") { return {Left: $0(v$1._1)}; }
            if (v$1.tag === "Right") { return {Right: v$1._1}; }
            $runtime.fail();
          }
        };
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const encodeClaimFODRequest = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor(ClaimFODRequestIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetAddressIsSymbol)({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.encodeStreetAddressWithApartment.encode(v2._1); }
          $runtime.fail();
        }
      }))(restaurantIdIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(phoneIsSymbol)(encodeWithOptionsOther))(emailIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const decodeClaimFODResponse = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericClaimFODResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ClaimFODResponseIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(resultIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dResult.decodeResult(Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dValidation$dTypes.decodeError))(Foreign$dGeneric$dClass.booleanDecode).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeClaimFODRequest = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericClaimFODRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ClaimFODRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetAddressIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.decodeStreetAddressWithApartment.decode)
  })())(restaurantIdIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode})())(phoneIsSymbol)(decodeWithOptionsOther)())(emailIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
export {
  ClaimFODRequest,
  ClaimFODRequestIsSymbol,
  ClaimFODResponse,
  ClaimFODResponseIsSymbol,
  decodeClaimFODRequest,
  decodeClaimFODResponse,
  decodeWithOptionsOther,
  emailIsSymbol,
  encodeClaimFODRequest,
  encodeClaimFODResponse,
  encodeWithOptionsOther,
  encodingOpts,
  eq,
  eqClaimFODRequest,
  eqClaimFODResponse,
  genericClaimFODRequest,
  genericClaimFODResponse,
  hasFieldClaimFODRequest,
  hasFieldClaimFODResponse,
  newtypeClaimFODRequest,
  newtypeClaimFODResponse,
  phoneIsSymbol,
  restaurantIdIsSymbol,
  resultIsSymbol,
  rpcMethodNameClaimFODRequest,
  showClaimFODRequest,
  showClaimFODResponse,
  streetAddressIsSymbol,
  unscrambleDecodeClaimFODRequest,
  unscrambleDecodeClaimFODResponse
};
